module.exports = __webpack_public_path__ + "static/media/033.b359740c.jpg";